<template>
  <!-- ############### Página referente ao login de acesso ao sistema ############### -->
  <div id="fundo-externo">
    <div id="formulario" class="container">
      <b-form class="form-signin text-center" @submit.stop.prevent>
        <b-img class="mb-4" :src="require('/static/images/logo_sgcq.png')" width="300" />
        <b-form-group class="m-1">
          <b-form-input id="email" placeholder="E-mail" v-model="usuario.email"></b-form-input>
        </b-form-group>
        <b-form-group class="m-1">
          <b-form-input
            id="password"
            placeholder="Password"
            type="password"
            v-model="usuario.password"
          ></b-form-input>
        </b-form-group>
        <b-alert show variant="danger" v-if="mensagemErro">{{ mensagemErro }}</b-alert>
        <b-button id="bt-login" @click="login()" variant="primary" block>Login</b-button>
        <p class="text-muted mt-3">©2019-{{ currentTime.getFullYear() }}</p>
      </b-form>
    </div>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";

export default {
  name: "PaginaDeLogin",
  components: {},

  data() {
    return {
      usuario: {
        email: "",
        password: "",
      },
      currentTime: new Date(),
      mensagemErro: null,
    };
  },

  methods: {
    login() {
      this.store
        .EFETUAR_LOGIN(this.usuario)
        .then(() => {
          setTimeout(() => {
            this.$router.push({ path: "/sgcq" });
            this.mensagemErro = "";
          }, 1000);
        })
        .catch((erro) => {
          if (erro.request.status === 400 || erro.request.status === 401) {
            this.mensagemErro = "Login ou senha inválido(s)!";
          }
        });
    },
  },

  setup() {
    const store = useSgcqStore();
    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped>
#fundo-externo {
  background-image: url("../../static/images/home_background.JPG");
  background-repeat: no-repeat;
  background-size: 100%;
  bottom: 0;
  color: black;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  background-size: cover;
}

#formulario {
  margin-top: 8%;
}

.form-signin {
  max-width: 28em;
  padding-top: 3em;
  padding-bottom: 3em;
  padding-left: 2em;
  padding-right: 2em;
  margin: auto;
  margin-top: 2em;
  background-color: #f5f5f5a8;
}
.form-signin .form-control {
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
